import React, { Component } from "react";
import "./BusReservations.css";
import "react-overlay-loader/styles.css";
import BGRSearchFilter from "../components/bgrComponents/BGRSearchFilter";
import BGRListView from "../components/bgrComponents/BGRListView";
import BGRCreateEditModal from "../components/bgrComponents/BGRCreateEditModal";
import { Loader } from "react-overlay-loader";
import axios from "axios";
import { ToastContainer, ToastStore } from "react-toasts";
import { B2B_PROXY } from "./assets/config";

export default class BusReservations extends Component {
  constructor(props) {
    super(props);
    this.handleSearchBGR = this.handleSearchBGR.bind(this);
    this.handleViewBGR = this.handleViewBGR.bind(this);
    this.handleCreateNewBGR = this.handleCreateNewBGR.bind(this);
    this.handleEditBGR = this.handleEditBGR.bind(this);
    this.handleToggleModal = this.handleToggleModal.bind(this);
    this.handleSubmitBGR = this.handleSubmitBGR.bind(this);
    this.handleCloseRejectBGR = this.handleCloseRejectBGR.bind(this);
    this.handleUnsubmitBGR = this.handleUnsubmitBGR.bind(this);
    this.handleChangeOfSearchFields =
      this.handleChangeOfSearchFields.bind(this);

    this.myRef = React.createRef();

    this.state = {
      loadingSpinner: false,
      displayCreateEditModal: false,
      bgrLists: [],
      currentPage: 1,
      totalItems: 0,
      currentEditList: null,
      searchFields: {
        passportNumber: "",
        reservationNumber: "", // Refactored from reservationId
        licensePlate: "",
        transportCompany: "",
        reservationStatus: "",
        travelDate: "",
        travelTime: "00:00",
        creationDate: "",
        creationTime: "00:00",
      },

      lang: this.props.lang,
      credentials: {
        userGroupCode: localStorage.getItem("userid"),
        userName: localStorage.getItem("UserName"),
        password: localStorage.getItem("Password"),
        lang: "EN",
      },
    };
  }

  componentDidMount() {
    if (
      localStorage.getItem("Authenticated") === "false" ||
      localStorage.getItem("Authenticated") === null ||
      process.env.REACT_APP_BGR_ENABLED !== "true"
    ) {
      this.props.history.push("/");
    } else {
      this.props.userHasAuthenticated();

      // Pull BGR-specific permissions into state
      this.setState({
        canCreateBGR: localStorage.getItem("CanCreateBGR") === "true",
        canEditBGR: localStorage.getItem("CanEditBGR") === "true",
        canEditOneMoreTime:
          localStorage.getItem("CanEditOneMoreTime") === "true",
        canAddBGRWithMRZ: localStorage.getItem("CanAddBGRWithMRZ") === "true",
        canSubmitBGR: localStorage.getItem("CanSubmitBGR") === "true",
        canUnSubmitBGR: localStorage.getItem("CanUnSubmitBGR") === "true",
        canCloseBGR: localStorage.getItem("CanCloseBGR") === "true",
        canRejectBGR: localStorage.getItem("CanRejectBGR") === "true",
      });
    }
    this.handleSearchBGR();
  }

  handleChangeOfSearchFields(event) {
    const { name, value } = event.target;
    this.setState((prevState) => ({
      searchFields: {
        ...prevState.searchFields,
        [name]: value,
      },
    }));
  }

  handleToggleModal(listData = null) {
    this.setState((prevState) => ({
      displayCreateEditModal: !prevState.displayCreateEditModal,
      currentEditList: listData,
    }));
  }

  handlePageChange = (newPage) => {
    if (newPage > 0) {
      this.setState({ currentPage: newPage }, () => {
        this.handleSearchBGR();
      });
    }
  };

  handleSearchBGR = () => {
    this.setState({ loadingSpinner: true });
    const { searchFields, credentials, currentPage } = this.state;

    const travelTS = searchFields.travelDate
      ? `${searchFields.travelDate} ${searchFields.travelTime}`
      : "";
    const creationTS = searchFields.creationDate
      ? `${searchFields.creationDate} ${searchFields.creationTime}`
      : "";

    const searchPayload = {
      ...searchFields,
      travelDate: travelTS,
      creationDate: creationTS,
      page: currentPage,
      credentials: credentials,
    };

    axios
      .post(B2B_PROXY + "/listBGRLists", searchPayload)
      .then((res) => {
        this.setState({
          bgrLists: res.data.reservations || [],
          totalItems: res.data.total || 0,
          loadingSpinner: false,
        });
      })
      .catch(() => {
        ToastStore.error("Failed to fetch BGR lists.", 5000);
        this.setState({ loadingSpinner: false });
      });
  };

  handleViewBGR = (listData) => {
    this.fetchFullBGRDetails(listData, true);
  };

  handleEditBGR = (listData) => {
    this.fetchFullBGRDetails(listData, false);
  };

  /**
   * Reusable helper to get full details (including passengers)
   * before opening the Create/Edit Modal
   */
  fetchFullBGRDetails = (listData, isViewMode) => {
    this.setState({ loadingSpinner: true });

    const payload = {
      reservationNumber: listData.reservationNumber,
      credentials: this.state.credentials,
    };

    axios
      .post(B2B_PROXY + "/listBGRLists", payload)
      .then((res) => {
        // Assuming the API returns { reservation: {...}, passengers: [...] }
        const fullDetail = res.data;

        const modalData = {
          ...fullDetail.reservation,
          passengers: fullDetail.passengers || [],
          isView: isViewMode,
        };

        this.setState({
          currentEditList: modalData,
          displayCreateEditModal: true,
          loadingSpinner: false,
        });
      })
      .catch((error) => {
        console.error("Error fetching BGR details:", error);
        ToastStore.error("Failed to fetch reservation details.", 5000);
        this.setState({ loadingSpinner: false });
      });
  };

  handleCreateNewBGR = () => {
    this.handleToggleModal(null);
  };

  updateBGRStatus = (reservationNumber, status) => {
    if (status === "SUBMITTED" && !this.state.canSubmitBGR) {
      ToastStore.error("You do not have permission to submit lists.");
      return;
    }

    if (status === "REJECTED" && !this.state.canRejectBGR) {
      ToastStore.error("You do not have permission to reject lists.");
      return;
    }

    this.setState({ loadingSpinner: true });

    const payload = {
      reservationStatus: status,
      reservationNumber: reservationNumber,
      credentials: this.state.credentials,
    };

    axios
      .post(`${B2B_PROXY}/updateBGRStatus`, payload)
      .then(() => {
        ToastStore.success(`BGR List updated to ${status} successfully.`);
        this.handleSearchBGR();
      })
      .catch((error) => {
        console.error("Status Update Error:", error);
        ToastStore.error(`Failed to update status to ${status}.`, 5000);
        this.setState({ loadingSpinner: false });
      });
  };

  handleSubmitBGR = (reservationNumber) => {
    this.updateBGRStatus(reservationNumber, "SUBMITTED");
  };

  handleUnsubmitBGR = (reservationNumber) => {
    this.updateBGRStatus(reservationNumber, "CREATED");
  };

  handleCloseRejectBGR = (reservationNumber, status) => {
    // status passed from view will be 'CLOSED' or 'REJECTED'
    this.updateBGRStatus(reservationNumber, status);
  };

  render() {
    const {
      canCreateBGR,
      canAddBGRWithMRZ,
      canEditBGR,
      canEditOneMoreTime,
      canSubmitBGR,
      canUnSubmitBGR,
      canCloseBGR,
      canRejectBGR,
    } = this.state;

    return (
      <div className="container main">
        <Loader fullPage loading={this.state.loadingSpinner} />
        <ToastContainer
          store={ToastStore}
          className="toaster"
          lightBackground
          position={ToastContainer.POSITION.TOP_CENTER}
        />
        <BGRSearchFilter
          searchFields={this.state.searchFields}
          onSearch={this.handleSearchBGR}
          onChange={this.handleChangeOfSearchFields}
          onCreate={this.handleCreateNewBGR}
          canCreate={canCreateBGR}
        />
        <BGRListView
          bgrLists={this.state.bgrLists}
          loading={this.state.loadingSpinner}
          currentPage={this.state.currentPage}
          totalItems={this.state.totalItems}
          onPageChange={this.handlePageChange}
          onView={this.handleViewBGR}
          onEdit={this.handleEditBGR}
          onSubmit={this.handleSubmitBGR}
          onUnsubmit={this.handleUnsubmitBGR}
          onCloseReject={this.handleCloseRejectBGR}
          userPermissions={{
            canEdit: canEditBGR,
            canEditOneMoreTime: canEditOneMoreTime,
            canSubmit: canSubmitBGR,
            canUnsubmit: canUnSubmitBGR,
            canClose: canCloseBGR,
            canReject: canRejectBGR,
          }}
          myRef={this.myRef}
        />
        {this.state.displayCreateEditModal && (
          <BGRCreateEditModal
            visible={this.state.displayCreateEditModal}
            listData={this.state.currentEditList}
            onClose={this.handleToggleModal}
            onSuccess={this.handleSearchBGR}
            credentials={this.state.credentials}
            lang={this.props.lang}
            canCreate={canCreateBGR}
            canUseMRZ={canAddBGRWithMRZ}
            port={this.props.port}
            onRequestPort={this.props.onRequestPort}
            lastScannedMRZ={this.props.lastScannedMRZ}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/BusReservations.js